import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M7 19h10c.55 0 1 .45 1 1s-.45 1-1 1H7c-.55 0-1-.45-1-1s.45-1 1-1z"
}), 'MinimizeRounded');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/MinimizeRounded.js
// module id = 4843
// module chunks = 2